import { combineReducers } from 'redux';
import notifications from './notificationReducer';
import signup from './signupReducer';
import stripe from './stripeReducer';

const rootReducer = combineReducers({
  notifications,
  signup,
  stripe,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./library/app/reducers/index.js